import { Results } from "@usereactify/search";
import React from "react";
import tw from "twin.macro";
import {
  SearchResultsOutputProps,
  withSearchResults,
} from "./withSearchResults";

import { AnalyticsViewItemListProvider } from "~/providers/AnalyticsViewItemListProvider";

const Wrapper = tw.div`
  pt-micro md:pt-maxi lg:gap-maxi
`;

const LoadingText = tw.span`
  pl-midi before:content-['Loading']
`;

export const SearchResults = withSearchResults(
  ({
    isMLG,
    renderError,
    renderResultCard,
    renderResultCardCallout,
    renderLoadMoreButton,
    renderNoResults,
    renderPaginationNumbered,
    pageSize,
    numColumns,
    collection,
  }: SearchResultsOutputProps) => {
    return (
      <AnalyticsViewItemListProvider
        itemListName={
          collection ? (collection.title ?? "Untitled Collection") : "Search"
        }
        itemListId={
          collection
            ? `collection:${collection.handle ?? "untitled"}`
            : "search"
        }
      >
        <Wrapper data-id="search-results-list">
          <Results
            listStyle={{
              display: "grid",
              gridAutoFlow: "row dense",
              gridGap: `${isMLG ? 32 : 16}px`,
              gridTemplateColumns: `repeat(${numColumns}, minmax(0, 1fr))`,
            }}
            renderNoResults={renderNoResults}
            renderError={renderError}
            renderResultCardProduct={renderResultCard}
            renderResultCardCallout={renderResultCardCallout}
            renderPaginationLoadMore={renderLoadMoreButton}
            renderLoading={LoadingText}
            renderPaginationNumbered={renderPaginationNumbered}
            pageSize={pageSize}
          />
        </Wrapper>
      </AnalyticsViewItemListProvider>
    );
  },
);
